var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.877,
    height: 25.877,
    viewBox: "0 0 25.877 25.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.938 0A12.938 12.938 0 1 1 0 12.938 12.938 12.938 0 0 1 12.938 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    d: "M439.8 245.048a3.145 3.145 0 0 0-.979-2.465 3.978 3.978 0 0 0-2.245-.895l-1.368-.2a2.683 2.683 0 0 1-1.35-.557 1.428 1.428 0 0 1-.456-1.114c0-1.064.777-1.874 2.195-1.874a3.783 3.783 0 0 1 2.123.538.782.782 0 0 0 .977-.085l.037-.037a.8.8 0 0 0-.116-1.234 4.825 4.825 0 0 0-2.242-.735v-1.623a.678.678 0 1 0-1.357 0V236.391a3.431 3.431 0 0 0-3.4 3.493 2.99 2.99 0 0 0 .878 2.3 4.118 4.118 0 0 0 2.279.962l1.418.2a2.09 2.09 0 0 1 1.317.506A1.618 1.618 0 0 1 438 245.1c0 1.165-.912 1.84-2.482 1.84a4.144 4.144 0 0 1-2.569-.716.81.81 0 0 0-1.038.094l-.067.066a.8.8 0 0 0 .09 1.216 5.444 5.444 0 0 0 3.092.967v1.185a.678.678 0 1 0 1.357 0v-1.234c2.035-.282 3.417-1.533 3.417-3.47z",
    transform: "translate(-422.766 -229.319)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.ac5b6469.svg";
export { ForwardRef as ReactComponent };